import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Music, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-950 border-t border-blue-500/20 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Logo & Slogan */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/0t37y2eh_IMG_4269.jpeg" 
                alt="AutoClean Logo" 
                className="w-16 h-16 object-contain brightness-110 contrast-110"
                style={{filter: 'drop-shadow(0 0 10px rgba(14, 165, 233, 0.3))'}}
              />
              <div>
                <div className="text-xl font-bold">
                  AutoClean
                </div>
                <div className="text-sm text-blue-400">Clean d'un clin d'œil</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Votre spécialiste en nettoyage automobile à Athis-Mons
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-500">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/realisations" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Nos Réalisations
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-blue-400 transition-colors">
                  Nous Contacter
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-500">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:0766845519" className="flex items-center text-gray-400 hover:text-blue-400 transition-colors">
                  <Phone className="h-4 w-4 mr-2 flex-shrink-0" />
                  <span>07 66 84 55 19</span>
                </a>
              </li>
              <li>
                <a href="mailto:entreprise.auto.clean@gmail.com" className="flex items-center text-gray-400 hover:text-blue-400 transition-colors">
                  <Mail className="h-4 w-4 mr-2 flex-shrink-0" />
                  <span className="break-all">entreprise.auto.clean@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start text-gray-400">
                <MapPin className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                <span>107 Avenue François Mitterrand<br />Athis-Mons</span>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-blue-500">Suivez-nous</h3>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/auto_clean91/" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-900 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 rounded-lg transition-all duration-300 hover:scale-110">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.tiktok.com/@auto_clean91" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-900 hover:bg-gradient-to-br hover:from-black hover:to-blue-600 rounded-lg transition-all duration-300 hover:scale-110">
                <img src="https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/lglcneuc_logo-tik-tok_578229-290.avif" alt="TikTok" className="h-5 w-5 object-contain" style={{mixBlendMode: 'screen', opacity: 0.9}} />
              </a>
              <a href="https://www.snapchat.com/add/auto_clean91" target="_blank" rel="noopener noreferrer" className="p-3 bg-gray-900 hover:bg-gradient-to-br hover:from-yellow-400 hover:to-yellow-600 rounded-lg transition-all duration-300 hover:scale-110">
                <img src="https://customer-assets.emergentagent.com/job_car-detailing-9/artifacts/iyt2vivk_Snapchat.png" alt="Snapchat" className="h-5 w-5 object-contain" style={{mixBlendMode: 'screen', opacity: 0.9}} />
              </a>
            </div>
            <p className="text-gray-400 text-sm mt-4">
              Rejoignez notre communauté et ne manquez aucune actualité !
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} AutoClean. Tous droits réservés.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            Spécialiste du nettoyage automobile à Athis-Mons
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;